import { Helmet } from "react-helmet-async";

const SITE_URL = "https://quotrak.com";
const DEFAULT_OG_IMAGE = "https://quotrak.com/opengraph.png";

function toAbsoluteUrl(url: string): string {
  if (url.startsWith("http://") || url.startsWith("https://")) return url;
  return `${SITE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
}

interface PageMetaProps {
  title: string;
  description: string;
  path?: string;
  ogImage?: string;
  noindex?: boolean;
}

export function PageMeta({ title, description, path = "/", ogImage, noindex }: PageMetaProps) {
  const canonical = `${SITE_URL}${path}`;
  const image = toAbsoluteUrl(ogImage ?? DEFAULT_OG_IMAGE);

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {path && <link rel="canonical" href={canonical} />}
      {noindex && <meta name="robots" content="noindex, nofollow" />}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="QuoTrak" />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1280" />
      <meta property="og:image:height" content="720" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
